/**
 * Convert camelCase to dash-case properties.
 */
export const camelToDash = (str) => str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();
//# sourceMappingURL=camel-to-dash.js.map